const initialState = {
  isLoading: false,
  agentRefreshing: false,
};

const spinnerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_LOADING_STATE":
      // Suppress setIsLoading(true) during agent background refresh — allow false through to ensure cleanup
      if (state.agentRefreshing && action?.payload === true) return state;
      return { ...state, isLoading: action?.payload };
    case "SET_AGENT_REFRESHING":
      return { ...state, agentRefreshing: action?.payload };
    default:
      return state;
  }
};

export default spinnerReducer;
